jQuery($ => {
  class PageNav {
    constructor(element) {
      this._ = element;
      this._element = $(element);
      this._trigger = this._element.find('.m-page-nav__link[aria-controls]');
      this._megaNav = null;
      this._parent = this._element.find('.m-page-nav__item--parent');

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._element.on('click', '.m-page-nav__link[aria-controls]', this.handleMegaNavClick);
      $(document).on('click', this.handleDocumentClick);

      this._parent.on('click', (e) => this.handleParentClick(e));
    }

    handleParentClick = (e) => {
      this._sublist = $(e.currentTarget).find('.m-page-nav__sub-list');
      this._parent = $(e.currentTarget).closest('.m-page-nav__item--parent');

      this._parent.toggleClass('m-page-nav__item--parent-open');
      this._sublist.toggleClass('m-page-nav__sub-list--open');
    }

    handleMegaNavClick = (e) => {
      e.preventDefault();

      const currentTarget = $(e.currentTarget);
      const ariaControls = currentTarget.attr('aria-controls');
      const megaNav = $(`#${ariaControls}`);

      this.toggleMegaNav(currentTarget, megaNav);
    }

    handleDocumentClick = (e) => {
      if (this._megaNav && !$(e.target).siblings('.m-page-nav__item-meganav').length) {
        this._megaNav.removeClass('m-page-nav__item-meganav--open');
        this._trigger.removeClass('m-page-nav__link--active');
        this._megaNav = null;
      }
    }


    toggleMegaNav(target, megaNav) {
      $('.m-page-nav__item-meganav').not(megaNav).removeClass('m-page-nav__item-meganav--open');
      $('.m-page-nav__link').not(target).removeClass('m-page-nav__link--active');

      if (megaNav.hasClass('m-page-nav__item-meganav--open')) {
        megaNav.removeClass('m-page-nav__item-meganav--open');
        target.removeClass('m-page-nav__link--active');
        this._megaNav = null;
      } else {
        megaNav.addClass('m-page-nav__item-meganav--open');
        target.addClass('m-page-nav__link--active');
        megaNav.focus();
        this._megaNav = megaNav;
      }
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.page_nav = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].page_nav = new PageNav(_[i], opt);
      else
        ret = _[i].page_nav[opt].apply(_[i].page_nav, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.m-page-nav').page_nav();
});